<template>
  <fieldset class="spa-terms-and-conditions">
    <legend class="sr-only">
      {{ tc('spaSoft.step2.termsAndConditionsLinkLabel') }}
    </legend>
    <div
      class="spa-terms-and-conditions__list"
      v-html="propertyData.checkoutPolicies"
    />
    <div class="flex-grid-1-col gutter-md terms-wrapper">
      <div
        class="input checkbox"
      >
        <label class="spa-terms-and-conditions__terms-label">
          <input
            id="termsAndConditions"
            name="termsAndConditions"
            type="checkbox"
            data-val="true"
            required
            :data-val-ischecked="tc('validations.ischecked')"
            data-field-type="CheckBoxSet"
            @change="updateTermsAndConditionsValidationStatus"
          >
          <span v-html="termsAndConditions" />
        </label>
        <span
          data-valmsg-for="termsAndConditions"
          data-valmsg-replace="true"
          class="field-validation-valid"
        />
      </div>
    </div>
  </fieldset>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'SpaTermsAndConditions',
    data() {
      return {
      }
    },
    computed: {
      ...mapState('spaSoft', ['propertyData']),
      ...mapGetters('i18n', ['tc']),

      propertyTermsAndConditions() {
        return this.propertyData?.termsAndConditions || ''
      },

      termsAndConditions() {
        const link = this.propertyTermsAndConditions.replace(/</g, '&lt;').replace(/>/g, '&gt;')

        const termsAndConditionCta = `<a href="${link}" target="_blank">${this.tc('spaSoft.step2.termsAndConditionsLinkLabel')}</a>`

        return this.tc('spaSoft.step2.termsAndConditions').replace('[[termsAndConditionsLink]]', termsAndConditionCta)
      }
    },
    methods: {
      updateTermsAndConditionsValidationStatus(event) {
        this.$emit('terms-and-conditions-validation-changed', event.target.checked)
      },
    }
  }
</script>
